import type { App } from 'vue';
import baseFr from '@nextories/vue-core-components/src/i18n/langs/fr/index';
import numberFormats from '@nextories/vue-core-components/src/i18n/langs/numberFormats';
import { createI18n, type I18nOptions } from 'vue-i18n';
import fr from '@/i18n/langs/fr/index';

export const i18n = createI18n({
  legacy: false,
  fallbackLocale: 'fr',
  warnHtmlMessage: false,
  locale: 'fr',
  // The core types the number styles as plain strings
  numberFormats: numberFormats as I18nOptions['numberFormats'],
  // Untyped schema: inferring the whole core messages is too deep for the compiler
  messages: {
    fr: {
      ...baseFr,
      ...fr,
    },
  } as I18nOptions['messages'],
});

export const i18nPlugin = {
  install: (app: App) => {
    app.use(i18n);
  },
};

export default i18nPlugin;
